import { addFlashNotification } from "_sirius/src/actions/flash_actions";
import i18n from "i18next";
import getAuth from "_sirius/src/services/auth";
import { CognitoAuthService } from "frontend/src/components/CognitoAuth/cognitoAuth";
import config from "../config/config";
import { getCognitoConfig } from "../config/cognitoConfig";

export const handleLogout = () => {
  // Cognito check must come first: the OKTA_* getters throw when Okta config is absent
  const cognitoConfig = getCognitoConfig();
  if (cognitoConfig) {
    // Fresh instance (no hook context here; in Okta mode there is no CognitoAuthProvider).
    // The provider's refresh timer survives until signOut's redirect unloads the page.
    void new CognitoAuthService(cognitoConfig).signOut();
    return;
  }

  getAuth(config.OKTA_ISSUER(), config.OKTA_CLIENT_ID()).signOut({
    postLogoutRedirectUri: window.location.origin,
  });
};

export const displayErrorFlash = () => {
  addFlashNotification({
    message: i18n.t("errors.default"),
    type: "error",
  });
};
